import { create } from "zustand";

const useStore = create((set) => ({
  onApp: false,
  setOnApp: (bol) => {
    set(() => ({
      onApp: bol
    }));
  },
  appN: null,
  setAppN: (num) => {
    set(() => ({
      appN: num
    }));
  },
  ChromeO: false,
  setChrome: (bol) => {
    set(() => ({
      ChromeO: bol
    }));
  },
  timestamp: 0,
  setTimestamp: (t) => {
    set(() => ({
      timestamp: t
    }));
  },
  loading: false,
  setLoading: (bol) => {
    set(() => ({
      loading: bol
    }));
  },
  socket: null,
  setSocket: (bol) => {
    set(() => ({
      socket: bol
    }));
  },
  pageId: false,
  setPageId: (pageId) => {
    set(() => ({
      pageId: pageId
    }));
  },
}));

export default useStore;
